// Layout.js
import React, { useRef, useEffect, useState } from 'react';
import Footer from './footer';
import Header from './header';
import { Script } from 'gatsby';

export default function Layout({ children, location }) {
  const headerRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    if (headerRef.current) {
      setHeaderHeight(headerRef.current.offsetHeight);
    }
  }, []);

  return (
    <>
      <Script>
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-TPF9SGK');
        `}
      </Script>
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-TPF9SGK"
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
          title="Google Tag Manager noscript"
        />
      </noscript>
      <Header
        location={location}
        headerRef={headerRef}
        headerHeight={headerHeight}
      />
      {location.pathname === '/' && (
        <div className="overflow-hidden bg-gray-300" style={{ marginTop: '0' }}>
          {children}
        </div>
      )}
      {location.pathname !== '/' && (
        <div
          id="main-content"
          className="overflow-hidden bg-gray-300"
          style={{ marginTop: headerHeight }}
        >
          {children}
        </div>
      )}
      <Footer />
    </>
  );
}
